import { Button, Popover } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { AppConfig, SessionStorage } from "../../../helpers";
import Alert from "../Alert";
import { CreateMemberSlotsBonusByCouponCode } from "../../../redux/actions/membersActions";

export class SlotGame extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errored: false,
      src: undefined,
    };
  }

  componentWillMount() {
    let src = this.props.src;
    try {
      this.setState({
        errored: false,
        src,
      });
    } catch (e) {

      const alternativeImage =src ?  (src.includes('_b.') ? require("../../../resources/images/winners_b.webp") : (src.includes('_h.') || src.includes('_t.')) ? require("../../../resources/images/winners_h.webp") : src.includes('_m.') ? require("../../../resources/images/winners_m.webp"): src.includes('_s.') ? require("../../../resources/images/winners_s.webp") : src.includes('_v.') ? require("../../../resources/images/winners_v.webp") : require("../../../resources/images/logo600.webp")) : require("../../../resources/images/logo600.webp")
      this.setState({
        errored: true,
        src: alternativeImage,
      });
    }
  }
  componentDidUpdate(prevProps){
    const {src} = this.props;
    if (prevProps.src !== src){
      this.setState({
        src:src
      })
    }
  }

  onError = () => {
    let src = this.props.src;
    const alternativeImage =src ?  (src.includes('_b.') ? require("../../../resources/images/winners_b.webp") : (src.includes('_h.') || src.includes('_t.')) ? require("../../../resources/images/winners_h.webp") : src.includes('_m.') ? require("../../../resources/images/winners_m.webp"): src.includes('_s.') ? require("../../../resources/images/winners_s.webp") : src.includes('_v.') ? require("../../../resources/images/winners_v.webp") : require("../../../resources/images/logo600.webp")) : require("../../../resources/images/logo600.webp")
    if (!this.state.errored) {
      this.setState({
        src: alternativeImage,
        errored: true,
      });
    }
  };
  navToGame=(gameId)=>{
    const {history} = this.props
    history.push(`/slots/game/${gameId}/1`)
  }
  validateCouponAndNavToGame=(gameId , bonusTypeId)=>{
    const {CreateMemberSlotsBonusByCouponCode} =this.props
    let data={
      bonusTypeId: bonusTypeId,
      couponCode: SessionStorage.couponCode,
      gameId: gameId
    }
    CreateMemberSlotsBonusByCouponCode(data)
  }
  render() {
    const { src, style, signedIn , gameId , history , className , fromCoupon , loadingCreateMemberSlotsBonus , errorCreateMemberSlotsBonus , bonusTypeId} = this.props;
    return (
      <>
        {signedIn ? (
          fromCoupon ? 
          <Popover
            overlayClassName="blue-popover"
            placement="bottom"
            arrowPointAtCenter
            content={
              <>
            <div>
              <p>Coupon Applied To This Game</p>
              <div>
              <Button
                type="primary"
                className="bet-slip-buttons"
                loading={loadingCreateMemberSlotsBonus}
                disabled={loadingCreateMemberSlotsBonus}
                onClick={()=>this.validateCouponAndNavToGame(gameId , bonusTypeId)}
                >
                  Play
              </Button>
              </div>
              {errorCreateMemberSlotsBonus && (
                  <div className="notice">
                    <Alert message={errorCreateMemberSlotsBonus} type="error" />
                  </div>
                )}
              </div>
              </>
              }
            trigger="click"
            zIndex={2}
          >
          <img className={className} src={this.state.src} style={{...style , '--slide-width': this.props.src.includes('_v.') ? '150px' : this.props.src.includes('_s.') ? '100px' : this.props.src.includes('_h.') ? '220px' : '100px'}} alt="slot-game" onError={this.onError} game-image-url={src.src}/> 
          </Popover>
          :
          <img className={className} src={this.state.src} style={{...style , '--slide-width': this.props.src.includes('_v.') ? '150px' : this.props.src.includes('_s.') ? '100px' : this.props.src.includes('_h.') ? '220px' : '100px'}} alt="slot-game" onClick={()=>this.navToGame(gameId)} onError={this.onError} game-image-url={src.src}/>
        ) : (
          <Popover
            overlayClassName="popup-slots"
            placement="bottom"
            arrowPointAtCenter
            content={<p> Please Sign in or Register </p>}
            trigger="click"
            zIndex={2}
          >
            <img className={className} src={this.state.src} style={{...style , '--slide-width': this.props.src.includes('_v.') ? '150px' : this.props.src.includes('_s.') ? '100px' : this.props.src.includes('_h.') ? '220px' : '100px'}}  alt="slot-game" onError={this.onError} game-image-url={this.props.src}/>
          </Popover>
        )}
      </>
    );
  }
}

const mapStateToProps = (_, initialProps) => (state) => {
  return {
    signedIn: state.auth.signedIn,
    loadingCreateMemberSlotsBonus: state.member.loadingCreateMemberSlotsBonus,
    errorCreateMemberSlotsBonus: state.member.errorCreateMemberSlotsBonus,
    loadingCreateMemberSlotsBonus: state.member.loadingCreateMemberSlotsBonus,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    CreateMemberSlotsBonusByCouponCode: (data) => {
      dispatch(CreateMemberSlotsBonusByCouponCode(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SlotGame);
